import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AppState } from '../AppState';

import { ScreenComponent } from './ScreenComponent';

export class TooManyAttempts extends ScreenComponent<AppState, {}> {
	public render() {
		return (
			<div className="main-container">
				<h2 className="too-many-attempts-headline">
					<FormattedMessage id="tooManyAttempts.title" />
				</h2>
				<div className="growing-container">
					<div className="too-many-attempts-icon"></div>
					<p className="too-many-attempts-text">
						<FormattedMessage id="tooManyAttempts.description" />
					</p>
				</div>
			</div>
		);
	}
}
